import { useState, useEffect, useCallback } from 'react';

/**
 * Custom hook for scroll-based navigation
 * Manages scroll-to-top button visibility and smooth scrolling
 */
export function useScrollNavigation() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const scrollToRef = useCallback((ref, offset = 0) => {
    if (ref?.current) {
      const element = ref.current;
      const y = element.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, []);

  const scrollToElement = useCallback((ref) => {
    setTimeout(() => {
      ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }, []);

  return {
    showScrollTop,
    scrollToTop,
    scrollToRef,
    scrollToElement,
  };
}
